import { SYNC_KEY_COSTOS_FOTOGRAMETRIA } from "../../../constantes";
import { CostosPlataformaService, TarifaFotogrametriaItem } from "../../generated/grpc/plataforma_costos_pb";
import { CostoFotogrametriaResponse } from "../../response/costos/CostoFotogrametriaResponse";
import { ServiceGetListBase } from "../base/ServiceGetListBase";
import { grpcCall, grpcClient } from "../grpc/grpcCall";

/** Variables de VISTA (`CostosPlataformaService`, gRPC). Pipeline las reusa para cotizar. */
export class CostoFotogrametriaListService extends ServiceGetListBase<CostoFotogrametriaResponse> {
  static readonly instance = new CostoFotogrametriaListService();
  private constructor() { super(); }

  /** Clave única del listado: deduplica `sync()` (dos pedidos simultáneos, un solo request). */
  protected readonly syncKey = SYNC_KEY_COSTOS_FOTOGRAMETRIA;

  /** gRPC-Web (`ListFotogrametria`): no eliminadas, por orden. */
  protected async fetchItems(): Promise<CostoFotogrametriaResponse[]> {
    const r = await grpcCall(() => grpcClient(CostosPlataformaService).listFotogrametria({}));
    return r.items.map(toCostoFotogrametriaResponse);
  }
}

/** Mensaje gRPC de la variable → respuesta. */
export function toCostoFotogrametriaResponse(t: TarifaFotogrametriaItem): CostoFotogrametriaResponse {
  return {
    id: t.id,
    isEliminado: false,
    variable: t.variable,
    descripcion: t.descripcion,
    valor: Number(t.valor),
    orden: t.orden,
  };
}
